import React, { Fragment, useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Header from './Header';
import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Alerts from "../../../components/Alerts/alerts";
import AddReward from './AddReward';
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader";

const RewardPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [branch, setBranch] = useState('');
  const [rewardPoints, setRewardPoints] = useState(0);
  const [redemtionSetting, setRedemtionSetting] = useState(0);
  const [rewardsHistory, setRewardsHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showReward, setShowReward] = useState(false);

  const handleRewardClick = () => {
    setShowReward(true);
  };

  const handleCloseReward = () => {
    setShowReward(false);
  };

  const handleSuccessfulRedeem = () => {
    fetchRewards(); // Re-fetch the rewards data
  };

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = () => {
    const userString = localStorage.getItem('user');
    const user = JSON.parse(userString);
    const userId = user['_id'];
    setLoading(true);
    DashboardService.GetRewards(userId).then((response) => {
      setLoading(false);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        setRewardsHistory(response.data.RewardsHistoryData);
        setRewardPoints(response.data.totalRemainingPoints);
        setRedemtionSetting(response.data.redemtionSetting);
      }
    }).catch((error) => {
      setLoading(false);
      const errContent = (error.response && error.response.data) || error.message || error.toString();
      if (errContent) {
        Alerts.swalErrorAlert(errContent);
      } else {
        Alerts.swalErrorAlert(t("Server Error, Please try again later."));
      }
    });
  };

  const styles = {
    creditPage: {
      fontFamily: 'Arial, sans-serif',
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    balanceSection: {
      background: 'linear-gradient(to bottom, #4a4a4a, #000000)',
      color: 'white',
      padding: '20px',
      borderRadius: '10px',
      textAlign: 'center',
    },
    walletIcon: {
      backgroundColor: '#f0e68c',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 auto 10px',
    },
    transactionsSection: {
      backgroundColor: '#f8f9fa',
      borderRadius: '10px',
      padding: '20px',
      marginTop: '20px',
    },
    topUp: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    topUpButton: {
      backgroundColor: '#000',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    filterDate: {
      position: 'relative',
      marginBottom: '20px',
    },
    filterInput: {
      width: '100%',
      padding: '10px',
      paddingRight: '30px',
      border: '1px solid #ccc',
      borderRadius: '5px',
    },
    calendarIcon: {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    transactionsList: {
      listStyleType: 'none',
      padding: 0,
    },
    transactionItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 0',
      borderBottom: '1px solid #eee',
    },
    transactionInfo: {
      display: 'flex',
      flexDirection: 'column',
    },
    transactionType: {
      fontWeight: 'bold',
    },
    transactionDate: {
      color: '#666',
      fontSize: '0.9em',
    },
    transactionAmount: {
      fontWeight: 'bold',
    },
  };

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <TransitionGroup>
            <CSSTransition component="div" classNames="TabsAnimation"
              appear={true} timeout={0} enter={false} exit={false}>
              <div>
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <Header branch={branch} setBranch={setBranch} />
                  </div>
                </div>
                <LoadingOverlay tag="div" active={loading}
                  styles={{ overlay: (base) => ({ ...base }) }}
                  spinner={<DNALoader />}>
                <div>
                  <header style={styles.header}>
                    <h1>Reward Points</h1>
                  </header>

                  <div style={styles.balanceSection}>
                    <div style={styles.walletIcon}>
                      <FontAwesomeIcon icon={faTrophy} style={{color:'black'}} />
                    </div>
                    <p>Reward Points</p>
                    <h2>{rewardPoints}</h2>
                  </div>

                  <div style={styles.transactionsSection}>
                  <div style={styles.topUp}>
                      <span>Redeem Points</span>
                      <button style={styles.topUpButton} onClick={handleRewardClick}>
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                    <h3>History</h3>

                    <ul style={styles.transactionsList}>
                      {rewardsHistory.map((reward, index) => (
                        <li key={index} style={styles.transactionItem}>
                          <div style={styles.transactionInfo}>
                            <span style={styles.transactionType}>{reward.reason}</span>
                            <span style={styles.transactionDate}>
                              {moment(reward.date).format('DD MMM, YYYY - HH:mm A')}
                            </span>
                          </div>
                          <span
                            style={{
                              ...styles.transactionAmount,
                              color: reward.status === 'Points In' ? 'green' : 'red'
                            }}
                          >
                            {reward.status === 'Points In' ? (
                              <>
                                {`+${reward.points}`} <span style={{ color: 'green' }}>↑</span>
                              </>
                            ) : (
                              <>
                                {`-${reward.points}`} <span style={{ color: 'red' }}>↓</span>
                              </>
                            )}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                </LoadingOverlay>
              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
      {showReward && 
        <AddReward 
          onClose={handleCloseReward} 
          availablePoints={rewardPoints} 
          onSuccessfulRedeem={handleSuccessfulRedeem}
          pointsToRmRatio={redemtionSetting.redemptionRate}
          minimumPoints={redemtionSetting.minimumPointsToRedeem}
          rmValue={redemtionSetting.pointsPerUnit}
        />
      }
    </Fragment>
  );
};

export default RewardPage;